import { FormikErrors } from "formik";
import { KlientkontoerklaeringTexts } from "../texts";
import { KlientkontoerklaeringFormValues } from "../../../interfaces/klientkontoerklaering";

export type IsCompleteHelpers = ReturnType<typeof isComplete>;

const getSectionComplete = (
  textSection: any,
  errors: FormikErrors<KlientkontoerklaeringFormValues>,
) => {
  return Object.keys(textSection).reduce((acc, key) => {
    if (errors[key] !== undefined) {
      return false;
    }
    return acc;
  }, true);
};

export const isComplete = (
  texts: KlientkontoerklaeringTexts,
  values: KlientkontoerklaeringFormValues,
  errors: FormikErrors<KlientkontoerklaeringFormValues>,
  touched,
  setTouched,
) => {
  // Section 1
  const advokatens_section_1AllTouched = Object.keys(
    texts.advokatens_section_1,
  ).reduce((acc, key) => {
    if (!texts.advokatens_section_1[key].id) return acc;
    return {
      ...acc,
      [texts.advokatens_section_1[key].id]: true,
    };
  }, {});

  advokatens_section_1AllTouched[
    texts.advokatens_section_1.advokatens_section_1_1_samleklientbankkonti.id
  ] = values[
    texts.advokatens_section_1.advokatens_section_1_1_samleklientbankkonti.id
  ].map(() => {
    return {
      pengeinstitution: true,
      regKontoNr: true,
      opretDato: true,
      cvKonto: true,
    };
  });
  const advokatens_section_1_complete = getSectionComplete(
    texts.advokatens_section_1,
    errors,
  );

  // Section 2
  const advokatens_section_2AllTouched = Object.keys(
    texts.advokatens_section_2,
  ).reduce((acc, key) => {
    if (!texts.advokatens_section_2[key].id) return acc;
    return {
      ...acc,
      [texts.advokatens_section_2[key].id]: true,
    };
  }, {});
  const advokatens_section_2_complete = getSectionComplete(
    texts.advokatens_section_2,
    errors,
  );
  const set_section_1_touched = () => {
    setTouched({
      ...touched,
      ...advokatens_section_1AllTouched,
    });
  };
  const set_section_1_and_2_touched = () => {
    setTouched({
      ...touched,
      ...advokatens_section_1AllTouched,
      ...advokatens_section_2AllTouched,
    });
  };
  const section3Complete = getSectionComplete(
    texts.advokatens_section_3,
    errors,
  );
  const revisors_0_intro_complete =
    !errors.revisors_0_intro_overholder_revisorloven &&
    !errors.revisors_0_intro_aftalebrev_indgået;

  const revisors_handling_1_complete = getSectionComplete(
    texts.revisors_handling_1,
    errors,
  );
  const revisors_handling_2_complete = getSectionComplete(
    texts.revisors_handling_2,
    errors,
  );
  const revisors_handling_3_complete = getSectionComplete(
    texts.revisors_handling_3,
    errors,
  );
  const revisors_handling_4_complete = getSectionComplete(
    texts.revisors_handling_4,
    errors,
  );
  const revisors_handling_5_complete = getSectionComplete(
    texts.revisors_handling_5,
    errors,
  );
  const revisors_handling_6_complete = getSectionComplete(
    texts.revisors_handling_6,
    errors,
  );
  const revisors_handling_7_complete = getSectionComplete(
    texts.revisors_handling_7,
    errors,
  );
  const revisors_handling_8_complete = getSectionComplete(
    texts.revisors_handling_8,
    errors,
  );
  const revisors_handling_9_complete = getSectionComplete(
    texts.revisors_handling_9,
    errors,
  );
  const revisors_handling_10_complete =
    values.advokatens_section_1_4_dispensation_ja_nej === "Nej"
      ? true
      : getSectionComplete(texts.revisors_handling_10, errors);
  const revisors_handling_11_complete = getSectionComplete(
    texts.revisors_handling_11,
    errors,
  );
  const revisors_handling_12_complete = getSectionComplete(
    texts.revisors_handling_12,
    errors,
  );
  const revisors_handling_13_complete = getSectionComplete(
    texts.revisors_handling_13,
    errors,
  );
  const revisors_handling_14_complete = getSectionComplete(
    texts.revisors_handling_14,
    errors,
  );
  const revisors_handling_15_complete = getSectionComplete(
    texts.revisors_handling_15,
    errors,
  );
  const revisors_handling_16_complete = getSectionComplete(
    texts.revisors_handling_16,
    errors,
  );
  const revisors_oevrige_oplysninger_complete = getSectionComplete(
    texts.revisors_oevrige_oplysninger,
    errors,
  );

  const advokatens_complete =
    advokatens_section_1_complete &&
    advokatens_section_2_complete &&
    section3Complete;
  const revisor_complete =
    advokatens_complete &&
    revisors_0_intro_complete &&
    revisors_handling_1_complete &&
    revisors_handling_2_complete &&
    revisors_handling_3_complete &&
    revisors_handling_4_complete &&
    revisors_handling_5_complete &&
    revisors_handling_6_complete &&
    revisors_handling_7_complete &&
    revisors_handling_8_complete &&
    revisors_handling_9_complete &&
    revisors_handling_10_complete &&
    revisors_handling_11_complete &&
    revisors_handling_12_complete &&
    revisors_handling_13_complete &&
    revisors_handling_14_complete &&
    revisors_handling_15_complete &&
    revisors_handling_16_complete &&
    revisors_oevrige_oplysninger_complete;
  return {
    advokatens_section_1_complete,
    advokatens_section_2_complete,
    advokatens_complete,
    set_section_1_touched,
    set_section_1_and_2_touched,
    revisors_0_intro_complete,
    revisors_handling_1_complete,
    revisors_handling_2_complete,
    revisors_handling_3_complete,
    revisors_handling_4_complete,
    revisors_handling_5_complete,
    revisors_handling_6_complete,
    revisors_handling_7_complete,
    revisors_handling_8_complete,
    revisors_handling_9_complete,
    revisors_handling_10_complete,
    revisors_handling_11_complete,
    revisors_handling_12_complete,
    revisors_handling_13_complete,
    revisors_handling_14_complete,
    revisors_handling_15_complete,
    revisors_handling_16_complete,
    revisors_oevrige_oplysninger_complete,
    revisor_complete,
  };
};
